export interface AIModule {
  id: string;
  n: string;
  label: string;
  sub: string;
}

export const MODS: AIModule[] = [
  { id: "fiche",     n: "01", label: "Fiche produit",  sub: "Robe · nez · bouche · finale" },
  { id: "accord",    n: "02", label: "Accords",         sub: "Mets, fromages & éviter" },
  { id: "social",    n: "03", label: "Réseaux sociaux", sub: "Instagram · LinkedIn · Facebook" },
  { id: "argco",     n: "04", label: "Argumentaire",    sub: "Script de vente premium" },
  { id: "etiquette", n: "05", label: "Étiquette",       sub: "Étiquette & stop-rayon" },
  { id: "millesime", n: "06", label: "Millésime",       sub: "Qualité · météo · potentiel" },
];

export const LANGS = [
  { v: "fr", l: "FR" },
  { v: "en", l: "EN" },
  { v: "de", l: "DE" },
];
